<template>
	<div class="not-found m-4 flex">
		<h1 class="text-4xl mt-16 mx-auto">Vous vous êtes trompé de chemin ?</h1>
	</div>
</template>

<script>
export default {};
</script>

<style>
</style>